import styled from '@emotion/styled';
import { motion } from 'framer-motion';

export const Overlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  z-index: 99998;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 10vh;
  
  @media (max-width: 480px) {
    z-index: 99998;
    padding-top: 5vh;
  }
`;

export const PanelContainer = styled(motion.div)`
  width: 90%;
  max-width: 600px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  position: relative;
`;

export const PanelHeader = styled.div<{ colors: any }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 2px solid #e5e7eb;
  background: ${props => props.colors.primary};
`;

export const HeaderTitle = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s ease;
  font-size: 1.8rem;
  font-weight: bold;
  z-index: 100000;
  pointer-events: auto;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
  
  @media (max-width: 480px) {
    font-size: 2rem;
    padding: 10px 12px;
  }
`;

export const PanelContent = styled.div`
  padding: 24px;
  overflow-y: auto;
  max-height: calc(80vh - 80px);
`;

export const SettingGroup = styled.div`
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
  
  &:last-child {
    border-bottom: none;
  }
`;

export const SettingLabel = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
`;

export const SettingDescription = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  color: #6b7280;
  margin-bottom: 16px;
  line-height: 1.5;
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const ToggleButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const ToggleButton = styled.button<{ isActive: boolean; colors: any }>`
  padding: 8px 24px;
  border-radius: 8px;
  border: 2px solid ${props => props.isActive ? props.colors.primary : '#d1d5db'};
  background: ${props => props.isActive ? props.colors.primary : 'white'};
  color: ${props => props.isActive ? 'white' : '#6b7280'};
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: ${props => props.colors.primary};
    background: ${props => props.isActive ? props.colors.primary : `${props.colors.primary}1A`};
  }
`;

export const SliderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SliderButton = styled.button<{ colors: any }>`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 2px solid ${props => props.colors.primary};
  background: white;
  color: ${props => props.colors.primary};
  font-family: 'Poppins', sans-serif;
  font-size: 1.2rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover:not(:disabled) {
    background: ${props => props.colors.primary};
    color: white;
  }
  
  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export const SliderDisplay = styled.div`
  flex: 1;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
`;

export const ResetButton = styled.button<{ colors: any }>`
  padding: 8px 16px;
  border-radius: 8px;
  border: 2px solid #d1d5db;
  background: white;
  color: #6b7280;
  font-family: 'Poppins', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: ${props => props.colors.primary};
    background: ${props => `${props.colors.primary}1A`};
    color: ${props => props.colors.primary};
  }
`;

